import moment from 'moment';
import _ from 'underscore';

export function alphabeticalName(name) {
  const nameArray = name.split(' ')
  const lastName = nameArray.slice(1).join(' ')
  return `${lastName} ${nameArray.join(' ')}`
}

export function sortByLastName(fullName1, fullName2){
  return sort(alphabeticalName(fullName1), alphabeticalName(fullName2));
}

export function sortTableByLastName(row1, row2, key) {
  return sort(alphabeticalName(row1.original[key]), alphabeticalName(row2.original[key]));
}

export function sortList(list1, list2) {
  return sort(list1.sort()[0], list2.sort()[0])
}

export function sortTableByList(row1, row2, key) {
  return sort(row1.original[key].sort()[0], row2.original[key].sort()[0])
}


export function sortFromSQLTimeStamp(timeStamp1, timeStamp2) {
  const epoch1 = timeStamp1 ? moment(timeStamp1).unix() : 0;
  const epoch2 = timeStamp2 ? moment(timeStamp2).unix() : 0;
  return sort(epoch1, epoch2)
}

export function sortTableFromSQLTimeStamp(row1, row2, key) {
  const timeStamp1 = row1.original[key]
  const timeStamp2 = row2.original[key]
  const epoch1 = timeStamp1 ? moment(timeStamp1).unix() : 0;
  const epoch2 = timeStamp2 ? moment(timeStamp2).unix() : 0;
  return sort(epoch1, epoch2)
}

export function tableSort(row1, row2, key) {
  if (row1.original[key] < row2.original[key]) {
    return -1;
  } else if (row1.original[key] > row2.original[key]) {
    return 1;
  } else {
    return 0
  }
}


export function sort(param1, param2) {
  if (param1 < param2) {
    return -1;
  } else if (param1 > param2) {
    return 1;
  } else {
    return 0
  }
}
